import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  progress: {
    marginTop: theme.spacing(0.5),
  },
}));
